export default class TriggerType {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      translations: {
        de: {
          name: null,
          description: null
        },
        en: {
          name: null,
          description: null
        }
      },
      accountCount: 0,
      shortcut: ''
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      shortcut: this.shortcut,
      translations: this.translations
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/triggerType/model.js